import { render, staticRenderFns } from "./SelectCountry.vue?vue&type=template&id=70b5fc6e&"
import script from "./SelectCountry.vue?vue&type=script&lang=js&"
export * from "./SelectCountry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports